export default __webpack_public_path__ + "static/premioHome-1ab422156042aaeda32e6624209b0be3.png";